// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"96":"ab79cfd529552e53","1599":"47968ccac047d523","9700":"c96498935b3b3b6f"}[chunkId] + ".css";
};